require('./bootstrap');

// Properties
import name from './properties/name';
import parent from './properties/parent';
import instances from './properties/instances';
import children from './properties/children';

// Components
import Page from './components/Page';
import Btn from './components/Btn';
import Link from './components/Link';
import Form from './components/Form';
import Field from './components/Field';
import Banner from './components/Banner';
import PricingPlans from './components/PricingPlans';
import Footer from './components/Footer';
// import Icon from './components/Icon';
// import Alert from './components/Alert';

// Verra
import Verra from './Support/Verra';

Verra.property('name', name);
Verra.property('parent', parent);
Verra.property('instances', instances);
Verra.property('children', children);

Verra.component('page', Page);
Verra.component('btn', Btn);
Verra.component('link', Link);
Verra.component('form', Form);
Verra.component('field', Field);
Verra.component('banner', Banner);
Verra.component('footer', Footer);
Verra.component('pricingPlans', PricingPlans);
